import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

export type Option = { value: string; label: string };

@Component({
  selector: 'app-filtro-select',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './filtro-select.component.html',
  styleUrls: ['./filtro-select.component.scss']
})
export class FiltroSelectComponent implements OnChanges {
  /** Opciones del dropdown */
  @Input() options: Option[] = [];

  /** Valor actual (single o multiple) */
  @Input() value: Option | Option[] | undefined;

  /** Placeholder (texto dentro del control) */
  @Input() placeholder = 'Selecciona…';

  /** Comportamiento */
  @Input() searchable = false;
  @Input() clearable = true;
  @Input() multiple = false;
  @Input() disabled = false;

  /** Emite el valor tras cambios del usuario */
  @Output() valueChange = new EventEmitter<Option | Option[] | undefined>();

  /** Modelo interno para ngModel */
  model: Option | Option[] | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if ('value' in changes) this.model = this.value;
  }

  onChange(next: Option | Option[] | null): void {
    const normalized = next === null ? undefined : next;
    this.model = normalized;
    this.valueChange.emit(normalized);
  }
}
